import React, { useMemo } from "react";

import PropTypes from "prop-types";
import { useIntl } from "react-intl";

import { Link } from "ds/Button";
import Checkbox from "ds/Checkbox";
import Dialog from "ds/Dialog";
import useMediaQuery from "Hooks/useMediaQuery";

import * as S from "../EnvironmentGeneralSettings.styles";

const IndexingSetting = ({
  environment,
  onIndexingChange,
  restrict_robots,
  organization,
  project
}) => {
  const intl = useIntl();
  const onMobile = useMediaQuery("(max-width: 768px)");
  const isEnabled = useMemo(() => {
    return (
      environment.hasPermission &&
      environment.hasPermission("#edit") &&
      environment.type === "production"
    );
  }, [environment, organization, project]);

  return (
    <S.SettingWrapper>
      <S.IndexingWrapper>
        <Checkbox
          label={intl.formatMessage(
            {
              id: onMobile ? "is_hidden.title" : "is_hidden"
            },
            {
              b: (...chunks) => <strong>{chunks}</strong>
            }
          )}
          id={onMobile ? "is_hidden.title" : "is_hidden"}
          checked={restrict_robots}
          onCheckedChanged={onIndexingChange}
          disabled={!isEnabled}
          aria-disabled={!isEnabled}
          forId="environment-is-hidden-switch"
        />{" "}
        <Dialog
          title={intl.formatMessage({
            id: "is_hidden.info.title"
          })}
          analyticId="is_hidden.info.description"
          description={intl.formatMessage({
            id: "is_hidden.info.description"
          })}
          align="end"
          link={
            <Link
              analyticId="is_hidden.info.link"
              href={intl.formatMessage({
                id: "links.documentation.environment_search_engine_visibility"
              })}
            >
              {intl.formatMessage({
                id: "is_hidden.info.link"
              })}
            </Link>
          }
        />
      </S.IndexingWrapper>
      {!onMobile && (
        <S.HttpsBodyText bodyTextSize="small">
          {intl.formatMessage({ id: "is_hidden.description2" })}
        </S.HttpsBodyText>
      )}
      {onMobile && (
        <S.HttpsBodyText>
          {intl.formatMessage({ id: "is_hidden.description" })}
        </S.HttpsBodyText>
      )}
    </S.SettingWrapper>
  );
};

IndexingSetting.propTypes = {
  environment: PropTypes.object,
  onIndexingChange: PropTypes.func,
  restrict_robots: PropTypes.bool,
  goLive: PropTypes.string,
  organization: PropTypes.object,
  project: PropTypes.object
};

export default IndexingSetting;
